<p-card *ngIf="loading">
	<div class="fluid formgrid grid h-100">
		<div class="flex flex-column gap-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>
<p-panel *ngIf="!loading" styleClass="mb-6">
	<div class="grid">
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-6 fluid">
			<label for="description">Description<span class="requis">*</span></label>
			<input #descriptionItem type="text" [disabled]="this.item.item.numero !== 'DIVERS'" pInputText
				id="description" [(ngModel)]="this.item.item.description" autocomplete="off" autofocus />
			<small class="p-error" *ngIf="submitted && !this.item.item.description">La description
				est
				obligatoire.</small>
		</div>


	</div>

	<div class="grid mb-3" *ngIf="this.item.item">
		<div class="flex flex-column gap-2 col-12 lg:col-3 fluid">
			<label for="quantity">Quantite<span class="requis">*</span></label>
			<p-inputNumber #champQuantite [(ngModel)]="this.item.quantiteDemande">
			</p-inputNumber>
			<small class="p-error" *ngIf="submitted && !this.item.quantiteDemande">La quantité est obligatoire.</small>
		</div>

		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="demandeur">Demandeur<span class="requis">*</span></label>
			<p-dropdown #champDemandeur [options]="listeEmployes" [(ngModel)]="selectionDemandeur" optionLabel="nom"
				[showClear]="true" (onHide)="surFermetureDemandeur()" filter="true" filterBy="prenom,nom"
				appendTo="body" placeholder="Sélectionner un demandeur...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionDemandeur">
						<div>{{ selectionDemandeur.prenom }} {{ selectionDemandeur.nom }}</div>
					</div>
				</ng-template>
				<ng-template let-employe pTemplate="item">
					<div>
						<div>{{ employe.prenom }} {{ employe.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error" *ngIf="submitted && !selectionDemandeur">Le demandeur est obligatoire.</small>
			<!-- <input #champDemandeur type="text" pInputText id="demandeur" [(ngModel)]="demandeur" autocomplete="off"
					 /> -->
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="dateRequis">Date requise<span class="requis">*</span></label>
			<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateRequis" dateFormat="yy-mm-dd"
				[yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"
				placeholder="Lors du prochain transport réalisable"></p-calendar>
			<small class="p-error" *ngIf="submitted && !dateRequis">La date requise est obligatoire.</small>
		</div>
	</div>

	<div class="grid">
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="codeProjet">Code projet<span class="requis">*</span></label>
			<p-dropdown #champCodeProjet [disabled]="true" [options]="listeCodeProjet" [(ngModel)]="selectionCodeProjet"
				optionLabel="code" [showClear]="true" (onHide)="surFermetureCodeProjet()" filter="true"
				filterBy="code,nom" (onChange)="surChangementCodeProjet()" appendTo="body"
				placeholder="Sélectionner un code de projet...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionCodeProjet">
						<div>{{ selectionCodeProjet.code }}</div>
					</div>
				</ng-template>
				<ng-template let-code pTemplate="item">
					<div>
						<div>{{ code.code }} - {{ code.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error" *ngIf="submitted && !selectionCodeProjet">Le code de projet est obligatoire.</small>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="codeActivite">Code d'activité<span *ngIf="estCodeCategorieObligatoire"
					class="requis">*</span></label>
			<p-dropdown #champCodeActivite [options]="listeCodeActivite" [(ngModel)]="selectionCodeActivite"
				optionLabel="code" [disabled]="!selectionCodeProjet" (onChange)="surChangementCodeActivite()"
				[showClear]="true" (onHide)="surFermetureCodeActivite()" filter="true" filterBy="code,nom"
				appendTo="body" placeholder="Sélectionner un code d'activité...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionCodeActivite">
						<div>{{ selectionCodeActivite.code }}</div>
					</div>
				</ng-template>
				<ng-template let-code pTemplate="item">
					<div>
						<div>{{ code.code }} - {{ code.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error" *ngIf="submitted && estCodeActiviteObligatoire && !selectionCodeActivite">Le code
				d'activité est obligatoire.</small>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="codeCategorie">Catégorie de coût<span *ngIf="estCodeCategorieObligatoire"
					class="requis">*</span></label>
			<p-dropdown #champCodeCategorie [options]="listeCodeCategorie" [(ngModel)]="selectionCodeCategorie"
				optionLabel="code" [disabled]="!selectionCodeProjet || codeCategorieBloque" [showClear]="true"
				(onHide)="surFermetureCodeCategorie()" filter="true" filterBy="code,nom" appendTo="body"
				placeholder="Sélectionner une catégorie de coût...">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionCodeCategorie">
						<div>{{ selectionCodeCategorie.code }}</div>
					</div>
				</ng-template>
				<ng-template let-code pTemplate="item">
					<div>
						<div>{{ code.code }} - {{ code.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error" *ngIf="submitted && estCodeCategorieObligatoire && !selectionCodeCategorie">La
				catégorie de
				coût est obligatoire.</small>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="codeCategorie">Équipement<span
					*ngIf="selectionCodeProjet?.code == 'ENTRET' && selectionCodeActivite?.code == '280'"
					class="requis">*</span></label>
			<p-dropdown #champCodeEquipement [options]="listeCodeEquipement" [(ngModel)]="selectionCodeEquipement"
				optionLabel="code" [disabled]="codeEquipementBloque" [showClear]="true" filter="true"
				filterBy="code,nom" (onChange)="surChangementCodeEquipement()" appendTo="body"
				placeholder="Sélectionner un équipement..">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionCodeEquipement">
						<div>{{ selectionCodeEquipement.code }}</div>
					</div>
				</ng-template>
				<ng-template let-code pTemplate="item">
					<div>
						<div>{{ code.code }} - {{ code.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<small class="p-error"
				*ngIf="submitted && selectionCodeProjet?.code == 'ENTRET' && selectionCodeActivite?.code == '280' && !selectionCodeEquipement">La
				catégorie de coût est obligatoire.</small>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="codeCategorie">Extra</label>
			<p-dropdown #champCodeExtra [options]="listeCodeExtra" [(ngModel)]="selectionCodeExtra" optionLabel="code"
				[showClear]="true" filter="true" filterBy="code,nom" appendTo="body"
				placeholder="Sélectionner un extra..">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionCodeExtra">
						<div>{{ selectionCodeExtra.code }}</div>
					</div>
				</ng-template>
				<ng-template let-code pTemplate="item">
					<div>
						<div>{{ code.code }} - {{ code.nom }}</div>
					</div>
				</ng-template>
			</p-dropdown>
		</div>
		<div class="flex flex-column gap-2 col-12 md:col-6 lg:col-3 fluid">
			<label for="emplacement">Emplacement</label>
			<p-dropdown #champEmplacement [options]="listeEmplacement" [(ngModel)]="selectionEmplacement"
				optionLabel="code" [showClear]="true" filter="true" filterBy="code,nom" appendTo="body"
				placeholder="Sélectionner un emplacement..">
				<ng-template pTemplate="selectedItem">
					<div *ngIf="selectionEmplacement">
						<div>{{ selectionEmplacement.code }}</div>
					</div>
				</ng-template>
				<ng-template let-emplacement pTemplate="item">
					<div>
						<div>{{ emplacement | nomEmplacement }}</div>
					</div>
				</ng-template>
			</p-dropdown>
		</div>
	</div>

	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 col-12 fluid">
			<label for="note">Note</label>
			<input #champNote type="text" pInputText id="note" [(ngModel)]="this.item.note" autocomplete="off" />
		</div>

	</div>

	<div class="fluid formgrid grid">
		<div class="col-12 flex justify-content-end gap-2 mt-4">
			<p-button [disabled]="submitted" label="Enregistrer" class="" icon="pi pi-save" iconPos="left"
				(onClick)="Confirmer()"></p-button>
			<p-button label="Annuler" class="p-button-text p-ml-2" icon="pi pi-ban" iconPos="left" [outlined]="true"
				[disabled]="submitted" (onClick)="Annuler()"></p-button>
		</div>
	</div>

</p-panel>

<!------------ Precommande Pièces Jointes ------------>

<p-panel *ngIf="!loading">
	<h5>Pièces jointes</h5>
	<div class="p-4">
		<app-document [typeLienDocument]="ETypeLienDocument.ItemCommande" [showFolders]="false"
			[idLien]="item.itemCommandeId" [numero]="item.emplacement.code"></app-document>
	</div>
</p-panel>